define( function() {
	return ( /\?/ );
} );



/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/src/ajax/var/rquery.js
 ** module id = 888
 ** module chunks = 2
 **/